import { ReactNode } from 'react';

interface ISummaryGroupProps {
	children: ReactNode;
}
export const SummaryGroup = ({ children }: ISummaryGroupProps) => {
	return <div className='d-flex gap-3'>{children}</div>;
};
